import React, { useState, useEffect } from 'react';
import Step1 from '../components/Step1.jsx';
import Step2 from '../components/Step2.jsx'; 
import Step2otropais from '../components/Step2otropais.jsx'; 
import Step3 from '../components/Step3.jsx';
import Step4 from '../components/Step4.jsx';
import Step5 from '../components/Step5.jsx';
import Step6 from '../components/Step6.jsx';
import Step7 from '../components/Step7.jsx';
import Step9 from '../components/Step9.jsx';
import FormNavigation from '../components/FormNavigation.jsx';
import '../styles/form.css';

const initialFormData = {
  nombres: '',
  tipoDocumento: '',
  documento: '',
  fechaNacimiento: '',
  paisNacimiento: '',
  fechaExpedicion: '',
  lugarExpedicion: '',
  email: '',
  departamentoNacimiento: '',
  municipioNacimiento: '',
  departamentoExpedicion: '',
  municipioExpedicion: '',
  departamentoResidencia: '', 
  municipioResidencia: '',    
  direccionResidencia: '',
  barrioResidencia: '',
  celular: '',
  celularfamiliar: '',
  telefonofijo: '',
  nombrefamiliar: '',
  parentescofamiliar: '',
  nivelEducativo: '',
  estadoCivil: '',
  cajaCompensacion: 'COMFENALCO',
  arl: 'ARL SURA',
  pension: '',
  eps: '',
  cesantias: '',
  banco: '',
  tipoCuenta: '',
  numeroCuenta: '',
  cabezaHogar: '',
  numeroHijos: '',
  incluirBeneficiarios: '',
  afiliara: '',
  cantidadBeneficiarios: '',
  beneficiario1Nombre: '',
  beneficiario1Parentesco: '',
  beneficiario2Nombre: '',
  beneficiario2Parentesco: '',
  beneficiario3Nombre: '',
  beneficiario3Parentesco: '',
  beneficiario4Nombre: '',
  beneficiario4Parentesco: '',
  beneficiario5Nombre: '',
  beneficiario5Parentesco: '',
  beneficiario6Nombre: '',
  beneficiario6Parentesco: '',
  centroCosto: '',
  frenteObra: '',
  cargo: '',
  tipoContrato: '',
  laborDeterminada: '',
  salario: '',
  fechainicio: '',
  observaciones: '',
  documentoIdentidadFile: null,
  certificadoPensionesFile: null,
  certificadoEpsFile: null,
  certificacionBancariaFile: null,
  hojaVidaFile: null,
  documentosBeneficiariosFile: null, 
  documentosPadresFile: null,         
  certificadoEstudioFile: null,
  registroMatrimonioFile: null,
  declaracionUnionLibreFile: null,
  formatoMintrabajoFile: null,
};

const SALARIO_MINIMO = 1750905;
const SALARIO_MAXIMO = 15000000;
const MAX_FILE_SIZE = 500 * 1024; // 500 KB
const regexSoloLetras = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;
const regexSoloNumeros = /^[0-9]+$/;

function MultiStepForm() {
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [empresaNombre, setEmpresaNombre] = useState(localStorage.getItem('empresaNombre') || '');
  const [loginData, setLoginData] = useState({ usuario: '', password: '' });
  const [loginError, setLoginError] = useState('');

  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const [isSubmitted, setIsSubmitted] = useState(false);   

  const [departamentos, setDepartamentos] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [centrosCosto, setCentrosCosto] = useState([]);
  const [todosLosMunicipios, setTodosLosMunicipios] = useState([]);

  const getDepIdByName = (name) => {
    if (!name) return null;
    const dep = departamentos.find(d => String(d.nombre) === String(name));
    return dep ? dep.id : null;
  };

  // 1. Carga de datos públicos (No requieren Token) - Se ejecuta una sola vez al montar el componente
  useEffect(() => {
    fetch('https://api-utilidades.aliadosestrategicos360.com/api/departamentos')
      .then(res => res.json())
      .then(setDepartamentos)
      .catch(err => console.error("Error cargando departamentos:", err));

    fetch('https://api-utilidades.aliadosestrategicos360.com/api/municipios')
      .then(res => res.json())
      .then(setTodosLosMunicipios)
      .catch(err => console.error("Error cargando municipios:", err));

    fetch('https://api-utilidades.aliadosestrategicos360.com/api/cargos')
      .then(res => res.json())
      .then(setCargos)
      .catch(err => console.error("Error cargando cargos:", err));

    fetch('https://api-utilidades.aliadosestrategicos360.com/api/bancos')
      .then(res => res.json())
      .then(setBancos)
      .catch(err => console.error("Error cargando bancos:", err));
  }, []);

  // 2. Carga de datos privados (Requieren Token de la Empresa) - Sincronizado para recargas de app
  useEffect(() => {
    if (!token) {
      setCentrosCosto([]);
      return;
    }

    const headers = { 'Authorization': `Bearer ${token}` };

    fetch('https://api-utilidades.aliadosestrategicos360.com/api/centros-costo', { headers })
      .then(res => {
        if (res.status === 401 || res.status === 403) {
          handleLogout();
          throw new Error('Sesión inválida o expirada');
        }
        return res.json();
      })
      .then(data => {
        if (Array.isArray(data)) {
          setCentrosCosto(data);
        } else {
          console.error("La API no devolvió un array para centros de costo:", data);
        }
      })
      .catch(err => console.error("Error cargando centros de costo en el useEffect:", err));
  }, [token]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    try {
      const res = await fetch('https://api-utilidades.aliadosestrategicos360.com/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginData)
      });
      const contentType = res.headers.get('content-type') || '';
      let data;
      if (contentType.includes('application/json')) {
        data = await res.json();
      } else {
        const text = await res.text();
        throw new Error(text ? `Respuesta no JSON del servidor: ${text.slice(0,200)}` : 'Respuesta no JSON del servidor');
      }

      if (!res.ok) throw new Error(data.error || 'Error de credenciales');

      localStorage.setItem('token', data.token);
      localStorage.setItem('empresaNombre', data.empresaNombre);
      
      setToken(data.token);
      setEmpresaNombre(data.empresaNombre);

      // Solución asincronía: Disparo inmediato usando el token recién recibido
      fetch('https://api-utilidades.aliadosestrategicos360.com/api/centros-costo', { 
        headers: { 'Authorization': `Bearer ${data.token}` } 
      })
        .then(r => r.json())
        .then(setCentrosCosto)
        .catch(err => console.error("Error de disparo inmediato en centros de costo:", err));

    } catch (err) {
      console.error('Login error:', err);
      setLoginError(err.message || 'Error en el login');
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    setToken(null);
    setEmpresaNombre('');
    setFormData(initialFormData);
    setCurrentStep(1);
    setIsSubmitted(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'departamentoNacimiento') {
      setFormData((prev) => ({ ...prev, departamentoNacimiento: value, municipioNacimiento: '' }));
      setErrors((prev) => ({ ...prev, departamentoNacimiento: '', municipioNacimiento: '' }));
      return;
    }
    if (name === 'departamentoExpedicion') {
      setFormData((prev) => ({ ...prev, departamentoExpedicion: value, municipioExpedicion: '' }));
      setErrors((prev) => ({ ...prev, departamentoExpedicion: '', municipioExpedicion: '' }));
      return;
    }
    if (name === 'departamentoResidencia') {
      setFormData((prev) => ({ ...prev, departamentoResidencia: value, municipioResidencia: '' }));
      setErrors((prev) => ({ ...prev, departamentoResidencia: '', municipioResidencia: '' }));
      return;
    }

    if (name === 'incluirBeneficiarios' && value === 'NO') {
      setFormData((prev) => ({
        ...prev,
        incluirBeneficiarios: 'NO',
        amountBeneficiarios: '',
        documentosBeneficiariosFile: null,
        documentosPadresFile: null,
        certificadoEstudioFile: null,
        registroMatrimonioFile: null,
        declaracionUnionLibreFile: null,
        formatoMintrabajoFile: null,
        ...Array.from({ length: 6 }).reduce((acc, _, i) => {
          acc[`beneficiario${i + 1}Nombre`] = '';
          acc[`beneficiario${i + 1}Parentesco`] = '';
          return acc;
        }, {})
      }));
      setErrors((prev) => ({ ...prev, incluirBeneficiarios: '' }));
      return;
    }

    if (name === 'cantidadBeneficiarios') {
      const cantidad = Number(value);
      const nuevoFormData = { ...formData, cantidadBeneficiarios: value };

      for (let i = cantidad + 1; i <= 6; i++) {
        nuevoFormData[`beneficiario${i}Nombre`] = '';
        nuevoFormData[`beneficiario${i}Parentesco`] = '';
      }

      setFormData(nuevoFormData);
      setErrors((prev) => ({ ...prev, cantidadBeneficiarios: '' }));
      return;
    }

    if (name === 'salario') {
      const onlyNumbers = value.replace(/\D/g, '');
      setFormData((prev) => ({ ...prev, salario: onlyNumbers }));
      setErrors((prev) => ({ ...prev, salario: '' }));
      return;
    }

    if (name === 'tipoContrato') {
      setFormData((prev) => ({
        ...prev,
        tipoContrato: value,
        laborDeterminada: value === 'obralabor' ? prev.laborDeterminada : ''
      }));
      setErrors((prev) => ({ ...prev, tipoContrato: '' }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleFileChange = (e) => {
    const { name, files, multiple } = e.target;

    if (!files || files.length === 0) return;

    const newFilesArray = Array.from(files);

    // Limpiar error anterior
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    // Validar tamaño de los archivos
    for (const file of newFilesArray) {
      if (file.size > MAX_FILE_SIZE) {
        setErrors((prev) => ({
          ...prev,
          [name]: `El archivo "${file.name}" supera el tamaño máximo permitido de 500 KB. Por favor comprímalo antes de cargarlo.`,
        }));
        setFormData((prev) => ({
          ...prev,
          [name]: null,
        }));

        // Limpiar el input
        e.target.value = "";

        return;
      }
    }

    if (multiple) {
      setFormData((prev) => {
        const existingFiles = prev[name] ? Array.from(prev[name]) : [];

        const uniqueNewFiles = newFilesArray.filter(
          (newFile) =>
            !existingFiles.some(
              (extFile) => extFile.name === newFile.name
            )
        );

        return {
          ...prev,
          [name]: [...existingFiles, ...uniqueNewFiles],
        };
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: newFilesArray[0],
      }));
    }
  };

  const handleRemoveFile = (fieldName, indexToRemove) => {
    setFormData((prev) => {
      const existingFiles = prev[fieldName] ? Array.from(prev[fieldName]) : [];
      const updatedFiles = existingFiles.filter((_, idx) => idx !== indexToRemove);
      return { ...prev, [fieldName]: updatedFiles.length > 0 ? updatedFiles : null };
    });
  };

  const validateStep = () => {
    const newErrors = {};

    if (currentStep === 1) {
      if (!formData.nombres.trim()) newErrors.nombres = 'Este campo es obligatorio.';
      if (!regexSoloLetras.test(formData.nombres.trim())) newErrors.nombres = 'El nombre solo puede contener letras, tildes y espacios.';
      if (!formData.tipoDocumento) newErrors.tipoDocumento = 'Seleccione un tipo de documento.';
      if (!formData.documento.trim()) newErrors.documento = 'Este campo es obligatorio.';
      if (!regexSoloNumeros.test(formData.documento.trim())) newErrors.documento = 'El documento solo puede contener números.';
      if (!formData.fechaNacimiento) newErrors.fechaNacimiento = 'Seleccione su fecha de nacimiento.';
      if (!formData.paisNacimiento) newErrors.paisNacimiento = 'Seleccione un país de nacimiento.';

      // --- VALIDACIÓN DE EDAD MÍNIMA (15 años) ---
      if (!formData.fechaNacimiento) {
        newErrors.fechaNacimiento = 'Seleccione su fecha de nacimiento.';
      } else {
        const hoy = new Date(); // Captura la fecha real actual (Año 2026)
        const cumpleanos = new Date(formData.fechaNacimiento);

        // Ajuste de zona horaria para inputs tipo date (evita desfases de un día)
        if (formData.fechaNacimiento.includes('-') && !formData.fechaNacimiento.includes('T')) {
          cumpleanos.setMinutes(cumpleanos.getMinutes() + cumpleanos.getTimezoneOffset());
        }

        let edad = hoy.getFullYear() - cumpleanos.getFullYear();
        const mes = hoy.getMonth() - cumpleanos.getMonth();

        // Si no ha cumplido años este año todavía, restamos 1 a la edad
        if (mes < 0 || (mes === 0 && hoy.getDate() < cumpleanos.getDate())) {
          edad--;
        }

        if (edad < 15) {
          newErrors.fechaNacimiento = 'No se permite continuar: El aspirante debe tener mínimo 15 años.';
        }
      }
    }

    if (currentStep === 2) {
      if (!formData.departamentoNacimiento) newErrors.departamentoNacimiento = 'Este campo es obligatorio.';
      if (!formData.municipioNacimiento) newErrors.municipioNacimiento = 'Este campo es obligatorio.';
      if (!formData.fechaExpedicion) newErrors.fechaExpedicion = 'Este campo es obligatorio.';
      if (!formData.departamentoExpedicion) newErrors.departamentoExpedicion = 'Este campo es obligatorio.';
      if (!formData.municipioExpedicion) newErrors.municipioExpedicion = 'Este campo es obligatorio.';
      if (!formData.departamentoResidencia) newErrors.departamentoResidencia = 'Este campo es obligatorio.';
      if (!formData.municipioResidencia) newErrors.municipioResidencia = 'Este campo es obligatorio.';    
      if (!formData.barrioResidencia.trim()) newErrors.barrioResidencia = 'Este campo es obligatorio.';
      if (!formData.direccionResidencia.trim()) newErrors.direccionResidencia = 'Este campo es obligatorio.';
    }

    if (currentStep === 22) {
      if (!formData.paisNacimiento.trim()) newErrors.paisNacimiento = 'Este campo es obligatorio.';
      if (!formData.lugarExpedicion.trim()) newErrors.lugarExpedicion = 'Este campo es obligatorio.';
      if (!formData.fechaExpedicion) newErrors.fechaExpedicion = 'Este campo es obligatorio.';
      if (!formData.departamentoResidencia) newErrors.departamentoResidencia = 'Este campo es obligatorio.';
      if (!formData.municipioResidencia) newErrors.municipioResidencia = 'Este campo es obligatorio.';    
      if (!formData.barrioResidencia.trim()) newErrors.barrioResidencia = 'Este campo es obligatorio.';
      if (!formData.direccionResidencia.trim()) newErrors.direccionResidencia = 'Este campo es obligatorio.';
    }

    if (currentStep === 3) {
    
      const fijoRegex = /^\d{7,10}$/;

      // Validar Celular
      if (!formData.celular) {
        newErrors.celular = "Este campo es obligatorio.";
      } else if (!regexSoloNumeros.test(formData.celular.trim())) {
        newErrors.celular =
          "Solo se aceptan números. No ingrese letras, espacios ni caracteres especiales.";
      } else if (formData.celular.length !== 10) {
        newErrors.celular =
          "El número de celular debe tener exactamente 10 dígitos.";
}

      // Validar Celular Familiar
      if (!formData.celularfamiliar) {
        newErrors.celularfamiliar = "Este campo es obligatorio.";
      } else if (!regexSoloNumeros.test(formData.celularfamiliar.trim())) {
        newErrors.celularfamiliar =
          "Solo se aceptan números. No ingrese letras, espacios ni caracteres especiales.";
      } else if (formData.celularfamiliar.length !== 10) {
        newErrors.celularfamiliar =
          "El número de celular familiar debe tener exactamente 10 dígitos.";
}

      // Validar Teléfono Fijo (Flexibilizado a 7-10 dígitos)
      if (formData.telefonofijo && formData.telefonofijo.trim() !== '') {
        if (!regexSoloNumeros.test(formData.telefonofijo.trim())) {
          newErrors.telefonofijo = "Solo se aceptan números. No ingrese letras, espacios ni caracteres especiales.";
        } else if (!fijoRegex.test(formData.telefonofijo)) {
          newErrors.telefonofijo = 'El teléfono fijo debe tener entre 7 y 10 dígitos.';
        }
      }

      // Validaciones de Texto
      if (!formData.nombrefamiliar?.trim()) newErrors.nombrefamiliar = 'Este campo es obligatorio.';
      if (!formData.parentescofamiliar?.trim()) newErrors.parentescofamiliar = 'Este campo es obligatorio.';
      if (!regexSoloLetras.test(formData.nombrefamiliar?.trim())) newErrors.nombrefamiliar = 'El nombre solo puede contener letras, tildes y espacios.';
      if (!regexSoloLetras.test(formData.parentescofamiliar?.trim())) newErrors.parentescofamiliar = 'El parentesco solo puede contener letras, tildes y espacios.';
      // Validar Email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!formData.email?.trim()) {
        newErrors.email = 'Este campo es obligatorio.';
      } else if (!emailRegex.test(formData.email)) {
        newErrors.email = 'Ingrese un correo electrónico válido.';
      }
    }

    if (currentStep === 4) {
      if (!formData.nivelEducativo.trim()) newErrors.nivelEducativo = 'Este campo es obligatorio.';
      if (!formData.estadoCivil.trim()) newErrors.estadoCivil = 'Este campo es obligatorio.';
      if (!formData.eps.trim()) newErrors.eps = 'Seleccione una EPS.';
    }

    if (currentStep === 5) {
      if (!formData.tipoCuenta.trim()) newErrors.tipoCuenta = 'Este campo es obligatorio.';
      if (!formData.numeroCuenta.trim()) newErrors.numeroCuenta = 'Este campo es obligatorio.';
      if (!formData.banco.trim()) newErrors.banco = 'Seleccione un banco.';
    }

    if (currentStep === 6) {
      if (!formData.cabezaHogar.trim()) newErrors.cabezaHogar = 'Este campo es obligatorio.';
      if (!formData.numeroHijos.trim()) newErrors.numeroHijos = 'Este campo es obligatorio.';
      if (!regexSoloNumeros.test(formData.numeroHijos.trim())) newErrors.numeroHijos = 'Este campo solo puede contener números.';
      if (!formData.incluirBeneficiarios) newErrors.incluirBeneficiarios = 'Este campo es obligatorio.';

      if (formData.incluirBeneficiarios === 'SI') {
        if (!formData.cantidadBeneficiarios) newErrors.cantidadBeneficiarios = 'Este campo es obligatorio.';
        if (!formData.afiliara) newErrors.afiliara = 'Seleccione una opción.';

        for (let i = 1; i <= Number(formData.cantidadBeneficiarios); i++) {
          const nombre = formData[`beneficiario${i}Nombre`]?.trim();
          const parentesco = formData[`beneficiario${i}Parentesco`]?.trim();

          // Validar nombre
          if (!nombre) {
            newErrors[`beneficiario${i}Nombre`] = 'Este campo es obligatorio.';
          } else if (!regexSoloLetras.test(nombre)) {
            newErrors[`beneficiario${i}Nombre`] =
              'Solo se aceptan letras. Ingrese el nombre correctamente.';
          }

          // Validar parentesco
          if (!parentesco) {
            newErrors[`beneficiario${i}Parentesco`] = 'Este campo es obligatorio.';
          } else if (!regexSoloLetras.test(parentesco)) {
            newErrors[`beneficiario${i}Parentesco`] =
              'Solo se aceptan letras. Ingrese un parentesco válido.';
          }
        }
      }
    }

    if (currentStep === 7) {
      if (!formData.centroCosto.trim()) newErrors.centroCosto = 'Este campo es obligatorio.';
      if (!formData.tipoContrato.trim()) newErrors.tipoContrato = 'Este campo es obligatorio.';
      if (!formData.fechainicio.trim()) newErrors.fechainicio = 'Este campo es obligatorio.';
      if (!formData.cargo.trim()) newErrors.cargo = 'Este campo es obligatorio.';
      if (!formData.frenteObra.trim()) newErrors.frenteObra = 'Este campo es obligatorio.';


      if (formData.tipoContrato === 'obralabor' && (!formData.laborDeterminada || !formData.laborDeterminada.trim())) {
        newErrors.laborDeterminada = 'Especifique la labor determinada.';
      }

      const salario = Number(formData.salario);

      if (!formData.salario) {
        newErrors.salario = 'Este campo es obligatorio.';
      } else if (salario < SALARIO_MINIMO || salario > SALARIO_MAXIMO) {
        newErrors.salario = `El salario debe estar entre $${SALARIO_MINIMO.toLocaleString('es-CO')} y $${SALARIO_MAXIMO.toLocaleString('es-CO')}.`;
      }
    }

    if (currentStep === 9) {
      if (!formData.documentoIdentidadFile) newErrors.documentoIdentidadFile = 'La fotocopia del documento es obligatoria.';
      if (!formData.certificacionBancariaFile) newErrors.certificacionBancariaFile = 'La certificación bancaria es obligatoria.';
      
      if (formData.incluirBeneficiarios === 'SI') {
        if (!formData.documentosBeneficiariosFile || formData.documentosBeneficiariosFile.length === 0) {
          newErrors.documentosBeneficiariosFile = 'Debe cargar los documentos de identidad de los beneficiarios.';
        }
        if ((formData.afiliara === 'caja de compensación' || formData.afiliara === 'ambas') && !formData.formatoMintrabajoFile) {
          newErrors.formatoMintrabajoFile = 'El formato de Mintrabajo es obligatorio.';
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) {
      setCurrentStep((prev) => {
        if (prev === 1) return formData.paisNacimiento === 'otro' ? 22 : 2;
        if (prev === 2 || prev === 22) return 3;
        if (prev === 7) return 9;
        return Math.min(prev + 1, 9);
      });
    }
  };

  const handleBack = () => {
    setCurrentStep((prev) => {
      if (prev === 3) return formData.paisNacimiento === 'otro' ? 22 : 2;
      if (prev === 2 || prev === 22) return 1;
      if (prev === 9) return 7;
      return Math.max(prev - 1, 1);
    });
  };

  const handleManualSubmit = async () => {
    if (currentStep !== 9) return;
    if (!validateStep()) return;

    setIsSubmitting(true);

    try {
      const dataPayload = new FormData();
      dataPayload.append('empresaAsociada', empresaNombre);

      Object.keys(formData).forEach(key => {
        if (!key.endsWith('File')) {
          dataPayload.append(key, formData[key]);
        }
      });

      const camposArchivo = [
        'documentoIdentidadFile', 'certificadoPensionesFile', 'certificadoEpsFile',
        'certificacionBancariaFile', 'hojaVidaFile', 'documentosBeneficiariosFile',
        'documentosPadresFile', 'certificadoEstudioFile', 'registroMatrimonioFile',
        'declaracionUnionLibreFile', 'formatoMintrabajoFile'
      ];

      camposArchivo.forEach(campo => {
        const valor = formData[campo];
        if (valor) {
          if (Array.isArray(valor)) {
            valor.forEach(archivo => dataPayload.append(campo, archivo));
          } else {
            dataPayload.append(campo, valor);
          }
        }
      });

      const response = await fetch('https://automatizacion.aliadosestrategicos360.com/webhook/4fe2a704-45f8-4060-8df4-e7eabf4757ca', {
        method: 'POST',
        body: dataPayload
      });

      if (response.ok) {
        setIsSubmitted(true);
        setFormData(initialFormData);
        setCurrentStep(1);
      } else {
        throw new Error('Error al procesar la entrega en el servidor de n8n.');
      }
    } catch (error) {
      console.error(error);
      window.alert('Ocurrió un error en el envío: ' + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!token) {
    return (
      <div className="form-layout">
        <div className="login-card">
          <h2>Portal de Afiliaciones</h2>
          <p className="login-subtitle">Por favor ingrese con las credenciales de su empresa.</p>
          {loginError && <div className="error-banner">{loginError}</div>}
          <form onSubmit={handleLogin}>
            <div className="field-group">
              <label>Usuario</label>
              <input type="text" placeholder="Ej: Infraestructura" onChange={e => setLoginData({ ...loginData, usuario: e.target.value })} required />
            </div>
            <div className="field-group">
              <label>Contraseña</label>
              <input type="password" placeholder="••••••••" onChange={e => setLoginData({ ...loginData, password: e.target.value })} required />
            </div>
            <button type="submit" className="btn-login">Ingresar al Formulario</button>
          </form>
        </div>
      </div>
    );
  }

  if (isSubmitted) {
    return (
      <div className="form-layout">
        <div className="form-card text-center" style={{ padding: '40px' }}>
          <div className="form-header" style={{ marginBottom: '25px' }}>
            <div className="header-meta">
              <h1 style={{ color: '#28a745', fontSize: '1.8rem' }}>✓ Envío Procesado con Éxito</h1>
            </div>
            <p style={{ fontWeight: '600', color: '#6c757d' }}>Portal de Vinculaciones</p>
          </div>
          
          <div style={{ backgroundColor: '#f8f9fa', borderLeft: '5px solid #28a745', padding: '20px', borderRadius: '6px', margin: '20px 0', textAlign: 'left' }}>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', margin: 0 }}>
              Hemos recibido y almacenado tus datos de manera correcta. El proceso continuará con la verificación de la información y la validación de los documentos suministrados en la plataforma. Muchas gracias.
            </p>
          </div>

          <div className="navigation-row" style={{ justifyContent: 'center', marginTop: '30px' }}>
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={() => setIsSubmitted(false)}
              style={{ padding: '10px 25px' }}
            >
              Registrar Nuevo Formulario
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="form-layout">
      <div className="form-card">
        <div className="form-header">
          <div className="header-meta">
            <h1>Formulario de Vinculación</h1>
          </div>
          <p>Por favor revisar que la información diligenciada en cada campo sea correcta.</p>
        </div>

        <div className="multi-step-form">
          <div className={`step-content step-${currentStep}`}>
            {currentStep === 1 && <Step1 formData={formData} errors={errors} onChange={handleChange} />}

            {currentStep === 2 && (
              <Step2
                formData={formData}
                errors={errors}
                onChange={handleChange}
                departamentos={departamentos}
                municipiosNacimiento={todosLosMunicipios.filter(m => {
                  const depId = m.id_departamento || m.departamento_id || m.idDepartamento;
                  const selectedId = getDepIdByName(formData.departamentoNacimiento);
                  return selectedId ? String(depId) === String(selectedId) : false;
                })}
                municipiosExpedicion={todosLosMunicipios.filter(m => {
                  const depId = m.id_departamento || m.departamento_id || m.idDepartamento;
                  const selectedId = getDepIdByName(formData.departamentoExpedicion);
                  return selectedId ? String(depId) === String(selectedId) : false;
                })}
                municipiosResidencia={todosLosMunicipios.filter(m => {
                  const depId = m.id_departamento || m.departamento_id || m.idDepartamento;
                  const selectedId = getDepIdByName(formData.departamentoResidencia);
                  return selectedId ? String(depId) === String(selectedId) : false;
                })}
              />
            )}

            {currentStep === 22 && (
              <Step2otropais
                formData={formData}
                errors={errors}
                onChange={handleChange}
                departamentos={departamentos}
                municipiosResidencia={todosLosMunicipios.filter(m => {
                  const depId = m.id_departamento || m.departamento_id || m.idDepartamento;
                  const selectedId = getDepIdByName(formData.departamentoResidencia);
                  return selectedId ? String(depId) === String(selectedId) : false;
                })}
              />
            )}
            
            {currentStep === 3 && <Step3 formData={formData} errors={errors} onChange={handleChange} />}
            {currentStep === 4 && <Step4 formData={formData} errors={errors} onChange={handleChange} />}
            
            {currentStep === 5 && (
              <Step5 
                formData={formData} 
                errors={errors} 
                bancos={bancos} 
                onChange={handleChange} 
              />
            )}
            
            {currentStep === 6 && <Step6 formData={formData} errors={errors} onChange={handleChange} />}
            {currentStep === 7 && (
              <Step7 formData={formData} errors={errors} onChange={handleChange} cargos={cargos} centrosCosto={centrosCosto} />
            )}
            {currentStep === 9 && (
              <Step9 formData={formData} errors={errors} onFileChange={handleFileChange} removeFile={handleRemoveFile} />
            )}
          </div>

          {isSubmitting ? (
            <div style={{ textAlign: 'center', color: '#0056b3', fontWeight: 'bold', padding: '15px' }}>
              Enviando información y archivos adjuntos...
            </div>
          ) : (
            <FormNavigation
              currentStep={currentStep === 22 ? 2 : currentStep}
              onBack={handleBack} 
              onNext={handleNext}
              showSubmit={currentStep === 9}
              onSubmit={handleManualSubmit}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default MultiStepForm;